export default {
  name: 'marking--remarkCause',
};